import React, { useRef, useState } from "react";
import { Button, Input, Space, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { Check2, XLg } from "react-bootstrap-icons";

const ManageCustomerContainer = ({ data }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const columns = [
    {
      title: "",
      dataIndex: "signup",
      key: "signup",
      width: "10%",
      render: (record) => (
        <div>
          {record === "1" ? (
            <Check2 style={{ color: "green", fontSize: "1.2rem" }} />
          ) : (
            <XLg style={{ color: "red", fontSize: "1rem" }} />
          )}
        </div>
      ),
    },
    {
      title: "نام",
      dataIndex: "FName",
      key: "FName",
      width: "40%",
      ...getColumnSearchProps("FName", "نام"),
    },
    {
      title: "شماره ",
      dataIndex: "phone",
      key: "phone",
      width: "40%",
      ...getColumnSearchProps("phone", "شماره "),
    },
  ];
  return (
    <div
      style={{ width: "96%", boxShadow: "0 0 6px #37373733", direction: "rtl" }}
    >
      <Table
        style={{ fontFamily: "iran-sans", fontSize: ".8rem" }}
        pagination={{ pageSize: 10 }}
        size={"middle"}
        columns={columns}
        dataSource={data}
      />
    </div>
  );
};

export default ManageCustomerContainer;
